export const shellGeometry = {
  sidebarDefault: 256,
  sidebarMin: 208,
  mainMin: 640,
  topbar: 52,
  projectRow: 32,
  chatRow: 28,
  appSwitcher: 40,
  rightPanelTab: 32,
  sidebarInset: 8,
  compactGap: 6,
  compactUnit: 8,
  titlebarControl: 28,
} as const;

export const runtimeGeometry = {
  statusPillHeight: 24,
  dockTabHeight: 32,
  fileRowHeight: 24,
  approvalCardMaxWidth: 560,
  artifactPanelDefault: 540,
  artifactPanelMin: 360,
  artifactPanelMax: 2400,
  terminalPadding: 8,
} as const;

export const appearanceThemes = ["dark", "light"] as const;
export type AppearanceTheme = (typeof appearanceThemes)[number];

/** Semantic CSS custom properties shared by the web and desktop shells. */
export const themeTokens = {
  canvas: "--color-canvas",
  surface: "--color-surface",
  surfaceRaised: "--color-surface-raised",
  sidebar: "--color-sidebar",
  foreground: "--color-foreground",
  foregroundMuted: "--color-foreground-muted",
  foregroundSubtle: "--color-foreground-subtle",
  border: "--color-border",
  borderStrong: "--color-border-strong",
  accent: "--color-accent",
  accentText: "--color-accent-text",
  accentForeground: "--color-accent-foreground",
  accentBorder: "--color-accent-border",
  focusRing: "--color-focus-ring",
  success: "--color-success",
  successText: "--color-success-text",
  successForeground: "--color-success-foreground",
  successSubtle: "--color-success-subtle",
  successBorder: "--color-success-border",
  warning: "--color-warning",
  warningText: "--color-warning-text",
  warningForeground: "--color-warning-foreground",
  warningSubtle: "--color-warning-subtle",
  warningBorder: "--color-warning-border",
  warningHover: "--color-warning-hover",
  info: "--color-info",
  infoText: "--color-info-text",
  infoForeground: "--color-info-foreground",
  destructive: "--color-destructive",
  destructiveText: "--color-destructive-text",
  destructiveForeground: "--color-destructive-foreground",
  destructiveSubtle: "--color-destructive-subtle",
  destructiveBorder: "--color-destructive-border",
} as const;

export const typographyTokens = {
  shell: "--font-sans",
  editorial: "--font-editorial",
  mono: "--font-mono",
} as const;
